enum DecisionEnum {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  WAITING = 'WAITING',
}

export default DecisionEnum